// src/pages/Auth/Login.js
import React, { useState } from 'react';
import './Login.css';
import { useLanguage } from '../../context/LanguageContext';
import { getTranslation } from '../../i18n/translations';

const Login = ({ onLogin, onNavigateToRegister, onNavigateToForgot }) => {
  const { language } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    
    if (!email) {
      newErrors.email = getTranslation('emailRequired', language);
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = getTranslation('emailInvalid', language);
    }
    
    if (!password) {
      newErrors.password = getTranslation('passwordRequired', language);
    } else if (password.length < 6) {
      newErrors.password = getTranslation('passwordMinLength', language);
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) return;

  setLoading(true);
  setErrors({});  

  try {
    const response = await fetch(
      'https://cp.fxpool.io/api/verify-otp.php', 
       
      {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, otp: password })  
    });

    const data = await response.json();

    if (!data.verified) {
       
      if (data.message?.toLowerCase().includes('otp') || data.message?.toLowerCase().includes('verify')) {
        alert(`Your account is not verified yet. Please check your email for the verification OTP.`);
      } else {
        setErrors({ general: data.message || 'Login failed' });
      }
      setLoading(false);
      return;
    }

    // User is verified - proceed with login
    const mockUser = {
      email,
      name: email.split('@')[0],
      token: 'mock-jwt-token-' + Date.now(),
    };

    localStorage.setItem('authToken', mockUser.token);
    localStorage.setItem('userData', JSON.stringify(mockUser));

    setLoading(false);

    if (onLogin) onLogin(mockUser);

    // Navigate to dashboard
    window.history.pushState({ page: 'dashboard' }, '', '/');
    window.dispatchEvent(new PopStateEvent('popstate'));
  } catch (err) {
    setLoading(false);
    setErrors({ general: 'Server error, please try again' });
  
  }
};


  const handleGoogleLogin = () => {
    // Mock Google login
 
  
  };

  const isFormValid = email && password && password.length >= 6;

  return (
    <div className="login-group">
      <div className="login-branding">
        <div className="branding-logo">
          <img src="/Logo.svg" alt="FX-Pool Logo" />
        </div>
        <h1 className="branding-title">{getTranslation('brandingTitle', language)}</h1>
        <p className="branding-subtitle">{getTranslation('brandingSubtitle', language)}</p>
      </div>
      <div className="login-block">
        <div className="login-block__center">
          <div className="login-block__logo-link">
            <img src="/Logo.svg" alt="FX-Pool logo" />
          </div>
          
          <div className="login-block__title-group">
            <h2 id="login-title" className="login-block__title">{getTranslation('logIn', language)}</h2>
            <p className="login-block__subtitle">{getTranslation('welcomeBack', language)}</p>
          </div>
          
          <form className="login-block__content-block" onSubmit={handleSubmit}>
            <div className="login-block__email">
              <label htmlFor="email">{getTranslation('email', language)}</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder={getTranslation('email', language)}
                className={`login-block__email-in ${errors.email ? 'error' : ''}`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-required="true"
                aria-invalid={!!errors.email}
                aria-describedby={errors.email ? "email-error" : ""}
              />
              {errors.email && <span id="email-error" className="error-text">{errors.email}</span>}
            </div>
            
            <div className="login-block__password">
              <label htmlFor="password">{getTranslation('password', language)}</label>
              <div className="login-block__password-wrapper">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder={getTranslation('password', language)}
                  className={`login-block__email-in ${errors.password ? 'error' : ''}`}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  aria-required="true"
                  aria-invalid={!!errors.password}
                  aria-describedby={errors.password ? "password-error" : ""}
                />
                <button type="button" className="login-visibility-icon" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? 'Hide password' : 'Show password'}>
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 16.01C14.21 16.01 16 14.22 16 12.01C16 9.8 14.21 8.01001 12 8.01001C9.79 8.01001 8 9.8 8 12.01C8 14.22 9.79 16.01 12 16.01Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 20C16.97 20 21.05 16.59 22 12C21.05 7.41 16.97 4 12 4C7.03 4 2.95 7.41 2 12C2.95 16.59 7.03 20 12 20Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.83 9.18C14.31 8.66 13.68 8.33 13 8.14M9.17 14.83C9.69 15.35 10.32 15.68 11 15.87M12 4C7.03 4 2.95 7.41 2 12C3.64 15.61 7.42 18.5 12 18.5C13.56 18.5 15.05 18.17 16.43 17.57M19.54 15.54L22 12C21.05 7.41 16.97 4 12 4M2 2L22 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  )}
                </button>
              </div>
              {errors.password && <span id="password-error" className="error-text">{errors.password}</span>}
            </div>

            <div className="login-block__addition">
              <div className="login-block__remember">
                <input type="checkbox" id="remember-me" />
                <label htmlFor="remember-me">{getTranslation('rememberMe', language)}</label>
              </div>
              <a href="#" onClick={onNavigateToForgot} className="login-block__password-forgot">{getTranslation('forgotPassword', language)}</a>
            </div>
            
            <button type="submit" className="login-block__btn" disabled={!isFormValid || loading}>
              {loading ? getTranslation('loading', language) : getTranslation('logIn', language)}
            </button>
          </form>
          
          <div className="login-block__separator">{getTranslation('or', language)}</div>
<div
 className="login-block__social">

          <button className="login-block__social-btn" onClick={handleGoogleLogin}>
            <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="Google icon" />
            {getTranslation('signInWithGoogle', language)}
          </button>
</div>
          <div className="login-block__footer">
            <span className="login-block__footer-text">{getTranslation('dontHaveAccount', language)} </span>
            <a href="#" onClick={onNavigateToRegister} className="login-block__footer-link">{getTranslation('signUp', language)}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

